<app-menu-common url="hr"></app-menu-common>

@if (hrService.backendMissing()) {
	<div class="hr-backend-warn">Backend RH non déployé : la pointeuse ne peut pas enregistrer (voir docs/backend-brief-hr.md).</div>
}

<!-- Dit dès le PREMIER écran pourquoi les boutons de pointage seront grisés : découvrir la
     porte fermée après avoir tapé son PIN se lirait comme une panne. -->
@if (!clockMode) {
	<div class="hr-backend-warn">Le planning fait foi dans cet établissement : les heures sont comptées sur le planning,
		la pointeuse est désactivée. Pour l'activer : Paramètres → Établissements &amp; services → « Décompte des heures ».</div>
}

<div class="kiosk">
	<div class="kiosk-clock">{{ nowLabel }}</div>

	@switch (step) {
		@case ('pick') {
			<h2>Qui pointe ?</h2>
			<div class="employee-grid">
				@for (e of kioskEmployees; track e.id) {
					<!-- has_pin/pointages ne sont fiables que sur les fiches « trusted » (session
					     responsable RH ou propre fiche) : ailleurs on ne désactive ni n'étiquette rien. -->
					<button class="employee-btn" [class.present]="e.present" [disabled]="e.trusted && !e.hasPin" (click)="onPick(e)">
						<span class="name">{{ e.name }}</span>
						@if (e.present) {
							<span class="status">Présent depuis {{ e.since }}</span>
						} @else if (e.since) {
							<span class="status out">Parti à {{ e.since }}</span>
						}
						@if (e.trusted && !e.hasPin) {
							<span class="status nopin">PIN non défini (voir fiche employé)</span>
						}
					</button>
				}
			</div>
			@if (kioskEmployees.length === 0) {
				<div class="kiosk-empty">Aucun employé rattaché à ce magasin.</div>
			}
		}
		@case ('pin') {
			<h2>{{ selected?.name }}</h2>
			<!-- 4 chiffres minimum, 8 maximum : 4 points fixes, les suivants n'apparaissent
			     qu'une fois tapés — pour ne pas laisser croire que 8 sont obligatoires. -->
			<div class="pin-dots">
				@for (i of [0, 1, 2, 3, 4, 5, 6, 7]; track i) {
					@if (i < 4 || pin.length > i) {
						<span class="dot" [class.filled]="pin.length > i"></span>
					}
				}
			</div>
			<div class="pin-pad">
				@for (d of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track d) {
					<button class="pad-btn" (click)="onDigit(d)">{{ d }}</button>
				}
				<button class="pad-btn small" (click)="onClearPin()">C</button>
				<button class="pad-btn" (click)="onDigit(0)">0</button>
				<button class="pad-btn small" (click)="onBackToPick()">↩</button>
			</div>
			@if (errorMessage) {
				<div class="kiosk-error">{{ errorMessage }}</div>
			}
			<div class="punch-actions">
				<button class="punch-btn in" [class.suggested]="suggestedIo === 1" [disabled]="pin.length < 4 || posting || !clockMode" (click)="onPunch(1)">
					<mat-icon>login</mat-icon>
					Pointer l'arrivée
				</button>
				<button class="punch-btn out" [class.suggested]="suggestedIo === 2" [disabled]="pin.length < 4 || posting || !clockMode" (click)="onPunch(2)">
					<mat-icon>logout</mat-icon>
					Pointer le départ
				</button>
			</div>
		}
		@case ('done') {
			<div class="kiosk-done">
				<mat-icon>check_circle</mat-icon>
				<div>{{ doneMessage }}</div>
				<button mat-stroked-button (click)="onBackToPick()">OK</button>
			</div>
		}
	}
</div>
